import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  NgZone
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { Aplicativos, GrupoAplicativo } from '../../interfaces/interfaces';
import bsCustomFileInput from 'bs-custom-file-input';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-correccion-funcionalidades',
  templateUrl: './correccion-funcionalidades.component.html',
  styleUrls: ['./correccion-funcionalidades.component.scss']
})
export class CorreccionFuncionalidadesComponent implements OnInit {
  // Usuario Autenticado
  @Input() emailUser: string;
  @Input() nombreUser: string;
  // Acceso a controles de Input Files
  @ViewChild('otrosArchivos', { static: true })
  otrosArchivosInput: ElementRef;
  // Objeto form
  correccionFormDatos: FormGroup;
  // Tipos de aplicativo y grupos de aplicativos
  gruposAplicativos: GrupoAplicativo[];
  tiposAplicativos: Aplicativos[];
  idGrupoSeleccionado: number;
  idAplicativoSeleccionado: number;
  // Visivilidad de los uploadings de los archivos
  subiendoOtrosArchivos = false;
  otrosArchivosError = false;
  // Limite fecha actual
  fechaActual: number;

  constructor(
    private dataService: DataService,
    private zone: NgZone,
    private router: Router,
    private notifier: NotifierService
  ) {
    // Obtener los aplicativos
    this.dataService.obtenerGruposSistemas().subscribe(data => {
      this.gruposAplicativos = data['data'];
    });
    // establecer fecha actual
    this.fechaActual = Date.now();
  }

  ngOnInit() {
    // Activar el FileChooser de bootstrap
    bsCustomFileInput.init();
    // Crear form
    this.correccionFormDatos = new FormGroup({
      nombreSistema: new FormControl(''),
      fechaTermino: new FormControl('', [Validators.required]),
      nombreSolicitante: new FormControl('', [Validators.required]),
      telefono: new FormControl('', [
        Validators.maxLength(10),
        Validators.required
      ]),
      extension: new FormControl('', [Validators.maxLength(5)]),
      justificacion: new FormControl('', [Validators.required]),
      problematica: new FormControl('', [Validators.required]),
      impactos: new FormGroup({}),
      solucion: new FormControl(''),
      beneficiariosDirectos: new FormControl(''),
      beneficiariosImplementacion: new FormControl(''),
      procesoActual: new FormControl(''),
      procesoPropuesto: new FormControl(''),
      costeo: new FormControl(''),
      otrosArchivos: new FormControl(''),
      tipoIniciativa: new FormControl('3'),
      usuarioRegistro: new FormControl(this.emailUser),
      nombreCapturista: new FormControl(this.nombreUser),
      aplicativosIdAplicativo: new FormControl('', [Validators.required]),
      correoSolicitante: new FormControl('', [Validators.required, Validators.email]),
      nombreCambioCorreccion: new FormControl('', [Validators.required])
    });
  }

  get fc() {
    return this.correccionFormDatos.controls;
  }
  get f() {
    return this.correccionFormDatos;
  }

  onSubmit() {
    this.dataService
      .correccionFuncionalidades(this.correccionFormDatos.value)
      .subscribe(
        data => {
          if (data['idIniciativa']) {
            this.notifier.notify(
              'success',
              'Nueva iniciativa para corrección de funcionalidades registrada correctamente'
            );
            this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
          }
        },
        error => {
          console.error(error);
          this.notifier.notify(
            'error',
            'Ha ocurrido un error al intentar registrar la iniciativa. Verifique su conexión de red o contacte al administrador.'
          );
        }
      );
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      this.subiendoOtrosArchivos = true;
      this.otrosArchivosError = false;
      this.dataService.subirArchivos(file,"",0).subscribe(
        (data: string) => {
          if (data) {
            this.correccionFormDatos.patchValue({
              otrosArchivos: data
            });
          }
          this.subiendoOtrosArchivos = false;
        },
        error => {
          console.error(error);
          this.otrosArchivosError = true;
          this.otrosArchivosInput.nativeElement.value = '';
          this.subiendoOtrosArchivos = false;
        }
      );
    }
  }

  onChangeGrupo(idGrupo: number) {
    this.idGrupoSeleccionado = idGrupo;
    this.dataService.obtenerAplicativos(idGrupo).subscribe(
      data => {
        if (data['data']) {
          this.tiposAplicativos = data['data'];
        }
      },
      error => {
        console.log(error);
      }
    );
  }
}
